import React from 'react';
import { useIntl } from 'react-intl';
import { Icon, Badge, Tooltip } from '@printdeal/ui-library';
import { getLineItemStateName, LineItemStates } from '@printdeal/business-logic';
// Translations
import { messages as lineItemMessages } from '../../../../translations/lineItems';
import { messages as lineItemDetailMessages } from '../../../../translations/lineItemDetails';

import LineItem from '../../../../../../types/cart/LineItem';
import { Environment } from '../../../../../../helpers/env';

interface ILineItemState {
  lineItem: LineItem;
  className?: string;
  enableTooltip?: boolean;
}

const LineItemState = ({ lineItem, className = '', enableTooltip = true }: ILineItemState) => {
  const intl = useIntl();
  const stateName = getLineItemStateName(lineItem, Environment);
  if (!stateName) return null;
  const lowerCaseStateName = stateName.toLowerCase() as Lowercase<LineItemStates>;
  const message = lineItemMessages[lowerCaseStateName] || lineItemMessages.unknown;

  const messageDescription = lineItemDetailMessages[lowerCaseStateName] || lineItemDetailMessages.unknown;

  return (
    <div className="pd-mt-1 pd-flex pd-items-center pd-gap-2">
      <Badge variant={message.color} className={className}>
        {intl.formatMessage(message)}
      </Badge>
      {enableTooltip && (
        <div className="pd-z-20">
          <Tooltip
            id={`state-${lineItem.id}`}
            className="pd-flex"
            placement="top"
            trigger={(
              <Tooltip.Trigger>
                <Icon
                  id={`tooltip-icon-${lineItem.id}`}
                  icon="info"
                  size="sm"
                  className="pd-text-dim-500"
                />
              </Tooltip.Trigger>
            )}
          >
            {intl.formatMessage(messageDescription)}
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default LineItemState;
